export const activeRegistrationFilters = (filters) =>
  Object.fromEntries(Object.entries(filters).filter(([, value]) => value !== "" && value !== null && value !== undefined));

export const serializeRegistrationsRequest = ({ competitionUuid, paginationModel, filters }) => ({
  competition_uuid: competitionUuid,
  page: paginationModel.page + 1,
  per_page: paginationModel.pageSize,
  ...activeRegistrationFilters(filters),
});

export const formatRegistrationAmount = (value, currencyCode, locale) => {
  if (value === null || value === undefined) return "—";
  if (!currencyCode) return new Intl.NumberFormat(locale).format(value);

  return new Intl.NumberFormat(locale, {
    style: "currency",
    currency: currencyCode,
    maximumFractionDigits: 2,
  }).format(value);
};

export const isEventDrawerItemActive = (pathname, item) => {
  if (item.exact) return pathname === item.link;
  if (item.nested) return pathname === item.link || pathname.startsWith(`${item.link}/`);
  return pathname === item.link;
};

export const registrationEmptyMessage = (filters) =>
  Object.values(filters).some(Boolean)
    ? "No hay resultados para los filtros aplicados."
    : "Aún no hay inscripciones en este evento.";

export const EMPTY_REGISTRATION_FILTERS = {
  search: "",
  tournament_id: "",
  status: "",
  origin: "",
  payment_type: "",
  date_from: "",
  date_to: "",
};

const registrationFilterKeys = Object.keys(EMPTY_REGISTRATION_FILTERS);

export const registrationFiltersFromSearch = (search = "") => {
  const params = search instanceof URLSearchParams ? search : new URLSearchParams(search);

  return registrationFilterKeys.reduce(
    (filters, key) => ({ ...filters, [key]: params.get(key) || "" }),
    {},
  );
};

export const registrationSearch = (filters = {}, registrationId = null) => {
  const params = new URLSearchParams();

  registrationFilterKeys.forEach((key) => {
    const value = filters[key];
    if (value !== "" && value !== null && value !== undefined) params.set(key, value);
  });

  if (registrationId !== null && registrationId !== undefined && registrationId !== "") {
    params.set("registration_id", registrationId);
  }

  const query = params.toString();
  return query ? `?${query}` : "";
};

const tournamentOperationDefinitions = [
  {
    key: "ready-to-finish",
    states: ["pending-finished"],
    titleId: "overview.tournaments.readyToFinish",
    descriptionId: "overview.tournaments.readyToFinishDescription",
    color: "warning",
    defaultExpanded: true,
  },
  {
    key: "final-stage-pending",
    states: ["final-stage-pending"],
    titleId: "overview.tournaments.finalStagePending",
    descriptionId: "overview.tournaments.finalStagePendingDescription",
    color: "info",
    defaultExpanded: true,
  },
  {
    key: "in-progress",
    states: ["underway", "group-stage-underway"],
    titleId: "overview.tournaments.inProgress",
    descriptionId: "overview.tournaments.inProgressDescription",
    color: "primary",
    defaultExpanded: true,
  },
  {
    key: "not-started",
    states: ["pending"],
    titleId: "overview.tournaments.notStarted",
    descriptionId: "overview.tournaments.notStartedDescription",
    color: "default",
    defaultExpanded: false,
  },
  {
    key: "finished",
    states: ["finished"],
    titleId: "overview.tournaments.finished",
    descriptionId: "overview.tournaments.finishedDescription",
    color: "success",
    defaultExpanded: false,
  },
];

export const groupTournamentsByOperationalState = (tournaments = []) =>
  tournamentOperationDefinitions
    .map((definition) => ({
      ...definition,
      tournaments: tournaments.filter((tournament) => definition.states.includes(tournament.state)),
    }))
    .filter((group) => group.tournaments.length > 0);

export const tournamentActionMessageId = (state) =>
  ({
    "pending-finished": "overview.actions.reviewAndFinish",
    "final-stage-pending": "overview.actions.startFinalStage",
    underway: "overview.actions.enterResults",
    "group-stage-underway": "overview.actions.enterResults",
    pending: "overview.actions.prepareTournament",
    finished: "overview.actions.viewResults",
  })[state] || "Administrar";
